export default __webpack_public_path__ + "static/media/youtube.89be5323.svg";